import React, { useContext } from 'react';
import SpecificDeviceOld from "./specificDeviceOld";
import SpecificDeviceNew from "./specificDeviceNew";
import { AuthContext } from "../../Library/contexts";
import { SELLER_DES } from '../../Library/constants';

const SpecificDevice = () => {
  const { profile } = useContext(AuthContext);
  const DESIGNATION = JSON.parse(window.localStorage.getItem("des"));

  return ((DESIGNATION !== SELLER_DES) && (!profile?.newPingFlow)) ? <SpecificDeviceOld /> : <SpecificDeviceNew />
}

export default SpecificDevice;
